<div class="content custom-scrollbar-light">
  <record-item *ngFor="let item of record" [record]="item"></record-item>
</div>
